import React, { FC, useState, useEffect } from 'react';
import { animated } from '@react-spring/web';
import styles from './A11ySwatches.module.scss';
import { Field } from 'formik';
import colorMethods from '../../../utils/color';
import a11y_reqs from '../../../data/a11y_reqs.json';
import cx from 'classnames';
import { useColorRamp } from '../ColorRampContext';

export interface A11ySwatchesProps {
  colors: any[];
  rootName?: string;
  colorIdx?: number;
  type: 'text' | 'ui';
  color?: any;
  id: string;
}

export const A11ySwatches: FC<A11ySwatchesProps> = ({ colors, rootName, colorIdx, id, type, color }) => {
  const [loaded, setLoaded] = useState(false);
  const [colorOpts, setColorOpts] = useState<any>([]);
  const [rgb, setRgb] = useState<number[] | boolean>(false);
  const { themeType } = useColorRamp();
  const [reqs, setReqs] = useState<Record<string, any> | null>(null);

  // @ts-ignore
  // const reqs: Record<string, any> = a11y_reqs[themeType][type];

  useEffect(() => {
    // @ts-ignore
    setReqs(a11y_reqs[themeType][type]);
  }, [themeType, type]);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    setColorOpts([
      { hex: '#ffffff', rgb: [255, 255, 255], hsl: [0, 0, 100] },
      ...colors,
      { hex: '#000000', rgb: [0, 0, 0], hsl: [0, 0, 0] },
    ]);
    if (colors && typeof colorIdx === 'number') {
      //@ts-ignore
      // const updated: any[] = [].concat(colors.slice(0, colorIdx), colors.slice(colorIdx + 1));
      setRgb(colors[colorIdx].rgb);
    }

    if (colors && !colorIdx && color) {
      setRgb(color.rgb);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colors]);

  return (
    <animated.div className={styles.a11ySwatches} style={{ width: '40px' }}>
      {loaded &&
        colorOpts &&
        // @ts-ignore
        colorOpts.map((color, contrastIdx) => {
          // if (JSON.stringify(rgb) === JSON.stringify(color.rgb)) return null;
          return (
            <span key={color.hex} className={styles.a11ySwatches__swatch}>
              {type === 'text' ? (
                <React.Fragment>
                  {colorIdx && rootName ? (
                    <Field
                      className={styles['formControl__radio--hidden']}
                      type='radio'
                      name={`${rootName}.${colorIdx}.contrastText`}
                      value={color.hex}
                      disabled={!colorMethods.contrast(rgb, color.rgb, 4.5)}
                      id={`${rootName}.${colorIdx}.contrastText--${contrastIdx}`}
                    />
                  ) : (
                    <input
                      className={styles['formControl__radio--hidden']}
                      type='radio'
                      name={`contrastText-${id}`}
                      value={color.hex}
                      disabled={!colorMethods.contrast(rgb, color.rgb, 4.5)}
                      id={`contrastText--${contrastIdx}-${id}`}
                    />
                  )}
                  <label
                    htmlFor={
                      rootName && colorIdx
                        ? `${rootName}.${colorIdx}.contrastText--${contrastIdx}`
                        : `contrastText--${contrastIdx}-${id}`
                    }
                    style={{
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: `hsl(${color.hsl[0]}, ${color.hsl[1]}%, ${color.hsl[2]}%)`,
                    }}
                    className={cx({
                      [styles['formControl__radioLabel--required']]:
                        reqs &&
                        reqs[id] &&
                        reqs[id][
                          contrastIdx > 0 && contrastIdx < colorOpts.length - 1
                            ? `${contrastIdx}0`
                            : contrastIdx === 0
                            ? 'white'
                            : 'black'
                        ],
                    })}
                  >
                    {contrastIdx > 0 && contrastIdx < colorOpts.length - 1
                      ? `${contrastIdx}0`
                      : contrastIdx === 0
                      ? 'White'
                      : 'Black'}
                  </label>
                </React.Fragment>
              ) : (
                <>
                  {rootName && colorIdx ? (
                    <Field
                      className={styles['formControl__radio--hidden']}
                      type='radio'
                      name={`${rootName}.${colorIdx}.contrastUi`}
                      value={color.hex}
                      disabled={!colorMethods.contrast(rgb, color.rgb, 3)}
                      id={`${rootName}.${colorIdx}.contrastUi--${contrastIdx}`}
                    />
                  ) : (
                    <input
                      className={styles['formControl__radio--hidden']}
                      type='radio'
                      name={`contrastUi-${id}`}
                      value={color.hex}
                      disabled={!colorMethods.contrast(rgb, color.rgb, 3)}
                      id={`contrastUi--${contrastIdx}-${id}`}
                    />
                  )}
                  <label
                    htmlFor={
                      rootName && colorIdx
                        ? `${rootName}.${colorIdx}.contrastUi--${contrastIdx}`
                        : `contrastUi--${contrastIdx}-${id}`
                    }
                    style={{
                      background: `hsl(${color.hsl[0]}, ${color.hsl[1]}%, ${color.hsl[2]}%)`,
                      width: '20px',
                      height: '20px',
                      display: 'block',
                    }}
                    className={cx(styles['formControl__radioLabel--ui'], {
                      [styles['formControl__radioLabel--required']]:
                        reqs &&
                        reqs[id] &&
                        reqs[id][
                          contrastIdx > 0 && contrastIdx < colorOpts.length - 1
                            ? `${contrastIdx}0`
                            : contrastIdx === 0
                            ? 'white'
                            : 'black'
                        ],
                    })}
                  >
                    <span className={styles.formControl__radioLabel__shadeIndicator}>
                      {contrastIdx > 0 && contrastIdx < colorOpts.length - 1
                        ? `${contrastIdx}0`
                        : contrastIdx === 0
                        ? 'W'
                        : 'B'}
                    </span>
                  </label>
                </>
              )}
            </span>
          );
        })}
    </animated.div>
  );
};
export default A11ySwatches;
